export const state = {
  wantBuyDetails: {},
  willOfferCountTotail: 0,
  wantOfferList : []
  }


// WEBPACK FOOTER //
// ./src/view/procurement/store/state.js